import React from "react";
import Group from "../../img/Course intro community.webp";
import Desktop from "../../img/Course intro desktop.webp";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import json2mq from "json2mq";
import { Link, useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    width: "100%",
    marginTop: "97px",
    marginBottom: isMobile ? "163px" : "242px",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: isMobile ? "center" : "space-evenly",
    alignItems: isMobile ? "center" : "flex-start",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: isMobile ? "center" : "flex-start",
    width: isMobile ? "fit-content" : "469px",
    textAlign: isMobile ? "center" : "left",
  },
  applyButton: {
    width: { xl: "307px", lg: "279px", xs: "224px" },
    height: "52px",
    borderRadius: "100px",
    background: "linear-gradient(100deg, #ff062e, #d00e2e);",
    color: theme.palette.white.main,
    textTransform: "none",
    fontSize: 15.5,
    fontWeight: 550,
    marginTop: isMobile ? "35px" : "44px",
  },
  icon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: "#d00e2e",
    bgcolor: theme.palette.white.main,
    ml: "3px",
    boxShadow:
      "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
  },
  typography: {
    title: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.montserrat.bold,
      fontSize: isMobile ? "32px" : "35px",
      marginTop: isMobile ? "0" : "50px",
    },
    text: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: "22px",
      marginTop: "35px",
      width: isMobile
        ? "290px"
        : { xl: "480px", lg: "480px", md: "480px", sm: "480px", xs: "290px" },
    },
  },
});

const Community = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { title, subtitle, buttonText } = useTranslation(pathname, "Community");

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );
  const md = useMediaQuery(
    json2mq({
      maxWidth: 1200,
      minWidth: 900,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1640,
      minWidth: 1201,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1641,
    })
  );

  const stylesHelper = () => {
    if (xs) return { img: { height: "302.5px", marginTop: "50px" } };
    if (md) return { img: { height: "302.5px" } };
    if (lg) return { img: { height: "302px" } };
    if (xl) return { img: { height: "464px" } };
  };

  return (
    <Box sx={classes.container}>
      {xs || md ? (
        ""
      ) : (
        <img
          src={Desktop}
          alt="img"
          style={stylesHelper() && stylesHelper().img}
        />
      )}
      <Box sx={classes.text}>
        <Typography sx={classes.typography.title}>{title}</Typography>
        <Typography sx={classes.typography.text}>{subtitle}</Typography>
        <Link
          to="/aplica/intro"
          style={{ textDecoration: "none", color: theme.palette.white.main }}
        >
          <Button
            sx={classes.applyButton}
            endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
          >
            {buttonText}
          </Button>
        </Link>
      </Box>
      <img src={Group} alt="img" style={stylesHelper() && stylesHelper().img} />
    </Box>
  );
};

export default Community;
